import { render } from "./OTPInvitationForm.vue?vue&type=template&id=510977d2&ts=true"
import script from "./OTPInvitationForm.vue?vue&type=script&lang=ts"
export * from "./OTPInvitationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/OTPInvitationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "510977d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('510977d2', __exports__)) {
    api.reload('510977d2', __exports__)
  }
  
  module.hot.accept("./OTPInvitationForm.vue?vue&type=template&id=510977d2&ts=true", () => {
    api.rerender('510977d2', render)
  })

}


export default __exports__